enum PotionTicketBook {
  Youth = 'youth',
  Love = 'love',
  Wisdom = 'wisdom'
}

enum PotionPromoType {
  Luck = 'luck',
  Pumpkin1 = 'pumpkin1',
  Pumpkin2 = 'pumpkin2',
  Pumpkin3 = 'pumpkin3'
}

function getTicketBookSequence(): PotionTicketBook[] {
  return [
    PotionTicketBook.Youth,
    PotionTicketBook.Love,
    PotionTicketBook.Wisdom
  ];
}

function getTicketBookNameForTicketBookId(ticketBookId: PotionTicketBook, promoType?: PotionPromoType): string {
  switch (ticketBookId) {
    case PotionTicketBook.Youth:
      return 'Youth';
    case PotionTicketBook.Love:
      return 'Love';
    case PotionTicketBook.Wisdom:
      if (promoType === PotionPromoType.Luck) {
        return 'Luck';
      }
      return 'Wisdom';
  }
}

export { PotionTicketBook, PotionPromoType, getTicketBookSequence, getTicketBookNameForTicketBookId };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/potion/_domain/models/ticket-book.ts